module.exports = {"410971001":"河南濮阳工业园区昌湖"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410971.json
// module id = 1614
// module chunks = 0